import React, { useEffect } from 'react';
import { Flex } from 'antd';
import styles from './Toast.module.scss';
import { ReactComponent as CrossIcon } from '../../../../assets/images/global-icons/cross_ic.svg';

interface ToastProps {
  content: string;
  onClose: () => void;
}

const Toast = ({ content, onClose }: ToastProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <Flex justify="space-between" align="center" className={styles.toast}>
      <span>{content}</span>
      <CrossIcon onClick={onClose} />
    </Flex>
  );
};

export default Toast;
